<div class="datatable-header table-responsive">
    <table #datatableHeader class="datatable table">
        <ng-content select="caption.dt-caption"></ng-content>
        <thead *ngIf="!hideHeader" class="dt-head">
            <tr>
                <ng-template *ngIf="config.columns" [ngForOf]="config.columns | slice: 0:(showActionColumn ? config.columns.length : -1)" let-column
                             ngFor>
                    <th (onSorted)="changeConfig('columns', $event)" *ngIf="column.hasOwnProperty('visible') ? column.visible : true"
                        [class.d-md-table-cell]="column.smallHide" [class.d-none]="column.smallHide"
                        [class.text-right]="column.sum"
                        [column]="column" [datatableSorting]="config.columns"
                        class="{{ column.addClass }}">
                        <span [innerHTML]="column.title"></span>
                        <i *ngIf="config && column.sort" [ngClass]="{ 'fa-sort-desc': column.sort === 'desc', 'fa-sort-asc': column.sort === 'asc' }"
                           class="ml-1 fa"></i>
                    </th>
                </ng-template>
            </tr>
        </thead>
        <ng-content *ngIf="hideHeader" select="thead.dt-head"></ng-content>
    </table>
</div>
<div class="datatable-body table-responsive">
    <table #datatable class="datatable table">
        <ng-content select="tbody.dt-body"></ng-content>
    </table>
</div>
<div class="datatable-footer table-responsive">
    <table #datatableFooter class="datatable table">
        <ng-content *ngIf="!hideSums" select="thead.dt-head"></ng-content>
        <ng-content *ngIf="showFooter" select="tfoot.dt-foot"></ng-content>
        <tfoot *ngIf="!hideSums && summable">
            <tr>
                <td *ngIf="hasSeparateCheckColumn" class="checkbox-cell"></td>
                <!-- only add Actions col in footer if admin or super -->
                <ng-template *ngIf="config.columns" [ngForOf]="config.columns | slice: 0:(showActionColumn ? config.columns.length : -1)" let-column
                             ngFor>
                    <td [class.d-md-table-cell]="column.smallHide" [class.d-none]="column.smallHide"
                        [class.text-right]="sums.hasOwnProperty(column.key)"
                        class="{{ column.addClass }}">
                        {{
                        sums.hasOwnProperty(column.key)
                            ? (sums[column.key] | legfiCurrency: 'USD':'symbol':'.2')
                            : ''
                        }}
                    </td>
                </ng-template>
            </tr>
        </tfoot>
    </table>
</div>
<div *ngIf="exportable || (config.footerActions && config.footerActions.length > 0)" class="export-option">
    <span (click)="exportData()" *ngIf="exportable" class="btn btn-outline-secondary">
        <img src="/assets/images/payhoa/other/export.svg"/> Export
    </span>
    <ng-container *ngFor="let action of config.footerActions">
        <span (click)="action.action()" *ngIf="exportable" class="btn btn-outline-secondary">
            <i *ngIf="!action.icon.endsWith('.svg')" class="fa fa-{{ action.icon }}"></i>
            <img *ngIf="action.icon.endsWith('.svg')" src="{{ action.icon }}"/>
            {{ action.label }}
        </span>
    </ng-container>
</div>
